(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardRiskSelfAssessmentController', Controller);

    Controller.$inject = ['$scope', 'commonRiskSelfAssessmentService', 'grcGovernanceProcessService'];

    function Controller($scope, commonRiskSelfAssessmentService, grcGovernanceProcessService) {

        // Get Active RCSA process
        grcGovernanceProcessService
            .getActiveRiskSelfAssessments()
            .then(function (govProcess) {

                var isGovProcDisabled = !_.isObject(govProcess) || _.isUndefined(govProcess.GovernanceProcessID);
                if (isGovProcDisabled) return;

                $scope.governanceProcess = govProcess;

                // Get Owners And Status
                commonRiskSelfAssessmentService
                    .statusAssessorsList()
                    .then(function (statusAssessors) {
                        $scope.statusAssessors = statusAssessors;
                    });
            });

        // Get Status
        $scope.getStatusCount = function (status) {
            return _.filter($scope.statusAssessors, { Status: status }).length;
        };

        // Get Completion percentage
        $scope.getCompletionPercentage = function (status) {
            if (_.isUndefined($scope.statusAssessors)) { return; }

            var completedCount = _.filter($scope.statusAssessors, { Status: 'Completed' }).length;
            var totalCount = $scope.statusAssessors.length;
            var perct = (completedCount / totalCount) * 100;

            return perct;
        };
    }
})();